(function() {

  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .controller('PendenciasRelatorioEleitoralController', PendenciasRelatorioEleitoralController);

  function PendenciasRelatorioEleitoralController(PendenciasRelatorioEleitoralService, PeriodoService, DataService) {

    var vm = this;

    vm.init = init;
    vm.convertDate = convertDate;
    vm.listarPendencias = listarPendencias;

    vm.init();

    function init() {
      vm.periodos = PeriodoService.loadPeriodosFiltro('desc');
      vm.periodoSelecionado = vm.periodos[0];
    }

    function convertDate(date) {
      return DataService.convertDate(date);
    }

    function listarPendencias() {
      vm.ultimoPeriodoExecutado = vm.periodoSelecionado;
      PendenciasRelatorioEleitoralService.listarPendencias(vm.periodoSelecionado).then(data => {
        vm.pendencias = data;
      });
    }

  }

})();
